import script from "./Status_Type.vue?vue&type=script&setup=true&lang=js"
export * from "./Status_Type.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__